if (!customElements.get('subscribe-popup-section')) {
    class subscribePopupSection extends HTMLElement {
        constructor() {
            super();
            let that=this;
            this.popupDom=this.querySelector("#subscribe-popup-section");
            this.subPopupEmailEl = this.querySelector('#subPopupEmail');
            this.subPopupTermsCheckEl = this.querySelector('#subPopupTermsCheck');
            this.subPopupEdmCheckEl = this.querySelector('#subPopupEdmCheck');
            // this.linkTextEl = this.querySelector('.linkText');
            this.linkIsSend=false;
            this.submitBtn=this.querySelector("#subPopupSubmitBtn")
            this.openSubscribePopupTime= Number(this.popupDom.getAttribute('data-popup-time'))*1000;
            this.subCustomApiUrl=this.getAttribute("data-subUrl");
            this.stepEl1=document.getElementById("subscribe-popup-step-1")
            this.stepEl2=document.getElementById("subscribe-popup-step-2")
            this.activateUrl=''
            function stringToBool(str) {
                return str === 'true';
            }
            this.isSubscribe=stringToBool(this.popupDom.getAttribute("data-isSubscribe"));
            this.isLogin=stringToBool(this.popupDom.getAttribute("data-isLogin"));
            this.customerId=this.popupDom.getAttribute("data-customerId");
            if(this.customerId){
                localStorage.setItem("phomemo_customerId",this.customerId);
                localStorage.setItem("phomemo_subPopupEmail",this.isSubscribe);
            }
            this.phomemo_customerId=localStorage.getItem("phomemo_customerId");
            this.phomemo_subPopupEmail=stringToBool(localStorage.getItem("phomemo_subPopupEmail"));
            this.lastLoginTime=localStorage.getItem("phomemo_lastLoginTime");
            this.nowTime=new Date().getTime();
            this.isTime=isOneDayDifference(this.lastLoginTime,this.nowTime)

            setTimeout(function(){
                that.openSubscribePopupMechanismFn()
            },this.openSubscribePopupTime)

            function isOneDayDifference(timestamp1, timestamp2) {
                const diffInMs = Math.abs(timestamp1 - timestamp2);
                const oneDayInMs = 24 * 60 * 60 * 1000;
                return diffInMs > oneDayInMs;
            }
            // this.linkTextEl.addEventListener("click",function(event){
            //     if(!that.linkIsSend){
            //         that.SendInviteEmailFn(that.phomemo_customerId)
            //         that.linkIsSend=true;
            //     }
            // })
            this.submitBtn.addEventListener("click", function(event){
                if(event.currentTarget.classList.contains('loading')) return;
                
                if (!that.subPopupEmailEl.checkValidity()) {
                    that.subPopupEmailEl.reportValidity();
                    that.subPopupEmailEl.parentElement.parentElement.querySelector('.error-message').style.display = "block";
                }else if(!that.subPopupTermsCheckEl.checkValidity()&&!that.isLogin){
                    that.subPopupTermsCheckEl.reportValidity();
                    that.subPopupTermsCheckE.parentElement.parentElement.querySelector('.error-message').style.display = "block";
                }else{
                    event.currentTarget.classList.add('loading');
                    if(that.phomemo_customerId||that.isLogin){
                        that.subEdmFn(that.customerId?that.customerId:that.phomemo_customerId)
                    }else{
                        that.createCustomFn(that.subPopupEmailEl.value)
                    }
                }
            // downloadUrlLink()
            })
            this.querySelector("#shopNowBtn").addEventListener('click', () => {
                if(that.querySelector(".copyText").innerHTML.includes("Copied")){
                    window.open('/account/login', '_blank');
                }
                that.ToggleSubPopup(false)
            })
            this.querySelectorAll(".copyText").forEach((item) => {
                item.addEventListener('click', () => {
                    if(item.classList.contains('nojump')){
                        that.ToggleSubPopup(false)
                        return
                    }else if(item.innerHTML.includes("Copied")){
                        window.open('/account/login', '_blank');
                    }
                })
            })
            const closeBtn = this.popupDom.querySelector('.close');
            closeBtn.addEventListener('click', () => {
                this.ToggleSubPopup(false)
            });
        }
        connectedCallback() {
           
        }
        openSubscribePopupMechanismFn(){
            //this.isTime=true;
            // 新用户弹窗
            if(!this.isSubscribe&&!this.isLogin&&!this.phomemo_customerId&&this.isTime){
                document.getElementById("subField1").style.display='block';
                this.ToggleSubPopup(true)
            }
            //未登录已注册未订阅
            if(!this.isLogin&&this.phomemo_customerId&&!this.phomemo_subPopupEmail&&this.isTime){
                this.submitBtn.querySelector('span').innerHTML='Subscribe Now';
                document.getElementById("subField1").style.display='none';
                this.ToggleSubPopup(true)
            }
            //已登录未订阅
            if(!this.isSubscribe&&this.isLogin&&this.isTime){
                this.submitBtn.querySelector('span').innerHTML='Subscribe Now';
                document.getElementById("subField1").style.display='none';
                this.ToggleSubPopup(true)
            }
        }
       
        ToggleSubPopup(type){
            localStorage.setItem("phomemo_lastLoginTime",new Date().getTime());
            this.querySelector("#subscribe-popup-section").style.display = type?"flex":"none";
        }
        createCustomFn(email){
            let tags='reg-popup-subscribe';
            let phomemo_ads=localStorage.getItem("phomemo_ads");
            if(phomemo_ads){
                tags+=`,${phomemo_ads}`;
            }
            const config = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body:JSON.stringify({
                    email:email,
                    tags:tags,
                    issubscribe:this.subPopupEdmCheckEl.checked
                })
            };
            fetch(this.subCustomApiUrl+'/api/shopify/custom/customerCreate',config)
            .then((response) => response.json())
            .then(async(response) => {
                if(response.code==1){
                    localStorage.setItem("phomemo_customerId",response.data);
                    localStorage.setItem("phomemo_subPopupEmail",this.subPopupEdmCheckEl.checked);
                    this.phomemo_customerId=response.data
                    //await this.SendInviteEmailFn(response.data)
                }
            }).then(() => { 
                this.submitBtn.classList.remove("loading");
                this.stepEl1.style.display = "none";
                this.stepEl2.style.display = "block";
            })
            // ToggleSubPopup(false);
            // window.open(driversDownloadUrl);
        }
        subEdmFn(customerId){
            const config = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body:JSON.stringify({
                    customerId,
                })
            };
            fetch(this.subCustomApiUrl+'/api/shopify/custom/subedm',config)
            .then((response) => response.json())
            .then((response) => {
                if(response.code==1){
                    localStorage.setItem("phomemo_subPopupEmail",true);
                    this.getEmailFn(this.phomemo_customerId)
                }
                this.submitBtn.classList.remove("loading");
                this.stepEl1.style.display = "none";
                this.stepEl2.style.display = "block";
            })
        }
        SendInviteEmailFn(email){
            const config = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body:JSON.stringify({
                    customerId:email,
                })
            };
            return fetch(this.subCustomApiUrl+'/api/shopify/custom/SendInviteEmail',config)
            .then(res=>{
                return this.getEmailFn(this.phomemo_customerId)
            })
        }
        getEmailFn(uid){
            const config = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body:JSON.stringify({
                    customerId:uid,
                })
            };
            return fetch(this.subCustomApiUrl+'/api/shopify/custom/getActivatEmailUrl',config)
            .then((response) => response.json())
            .then((response) => {
                this.activateUrl=response.data
            })
        }
        activateUrlFn(){
            if(this.activateUrl){
                window.location.href=this.activateUrl
            }

        }

    }
    customElements.define('subscribe-popup-section', subscribePopupSection);
}